module.exports = __webpack_public_path__ + "img/inktober_2020_11_disgusting.25deeae0.jpg";